import {
  isAndroid,
  isBrowser,
  isIOS,
  isMacOs,
  isSafari,
} from "react-device-detect"

export const isVisible = (platform: "ios" | "android") => {
  if (platform === "android" && (isAndroid || isBrowser)) return true
  if (platform === "ios" && (isIOS || (isMacOs && isBrowser && isSafari)))
    return true

  return false
}
